import { render, staticRenderFns } from "./colorcodingScores.vue?vue&type=template&id=354f7302&scoped=true&"
import script from "./colorcodingScores.vue?vue&type=script&lang=js&"
export * from "./colorcodingScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354f7302",
  null
  
)

export default component.exports